import * as React from 'react';

import './PageSection.css';
import { ClassNames } from '../../_helpers/ClassNames';
import { PageSectionDto, SectionImagesDto, SectionDto } from 'src/@types/api';
// import { sineInOut } from 'eases';
import * as ArrowRight from "./arrow-right.svg";
import * as ArrowLeft from "./arrow-left.svg";
import Image from '../Image/Image';
import { PictureRef } from 'src/@types/cms';
import Slider from '../Slider';
import { TranslatedMessage } from '../TranslatedMessage/TranslatedMessage';
import { SectionImages } from '../SectionImages/SectionImages';
import { Title } from '../Title/Title';
import { debounce } from 'lodash';
import { polyfill } from 'smoothscroll-polyfill';

export type PageSectionProps = PageSectionDto;
type state = {
    ImageMode: boolean;
    currentSlide: number;

    isMobile: boolean;
    teaserOpen?: string;
};
const scrollroot = (() => {

    if ('scrollingElement' in document) { return document.scrollingElement }

    /* tslint:disable */
    const doc = (document as any);
    const initial = doc.documentElement.scrollTop
    doc.documentElement.scrollTop = initial + 1

    const updated = doc.documentElement.scrollTop
    doc.documentElement.scrollTop = initial

    return (updated > initial ? doc.documentElement : doc.body)
    /* tslint:enable */
})();

polyfill();

const scrollbarWidth = (() => {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode!.removeChild(outer);

    return widthNoScroll - widthWithScroll;
})();

export class PageSectionWrapped extends React.Component<PageSectionProps, state> {
    // introTitle: React.RefObject<HTMLHeadingElement>;

    navContainer: React.RefObject<HTMLDivElement>;
    subNavContainer: React.RefObject<HTMLDivElement>;
    subNavTitleContainer: React.RefObject<HTMLDivElement>;

    container: React.RefObject<HTMLDivElement>;

    textColumn: React.RefObject<HTMLDivElement>;
    imageColumn: React.RefObject<HTMLDivElement>;

    scrolling: "text" | "image" = "text";

    ticking = false;

    scroll: {
        clientHeight: number,
        legends: HTMLDivElement[];
        text: {
            scrollHeight: number;
            scrollTop: number;
            knobRail: React.RefObject<HTMLDivElement>;
            knob: React.RefObject<HTMLDivElement>;
            knobRailHeight: number;
            knobHeight: number;
            dragging: boolean;
            startY: number;
            startScrollTop: number;
        },
        image: {
            scrollHeight: number;
            scrollTop: number;
            knobRail: React.RefObject<HTMLDivElement>;
            knob: React.RefObject<HTMLDivElement>;
            knobRailHeight: number;
            knobHeight: number;
            dragging: boolean;
            startY: number;
            startScrollTop: number;
        }
    } = {
            clientHeight: 0,
            legends: [],
            text: {
                scrollHeight: 0,
                scrollTop: 0,
                knob: React.createRef<HTMLDivElement>(),
                knobRail: React.createRef<HTMLDivElement>(),
                knobRailHeight: 0,
                knobHeight: 0,
                startY: 0,
                startScrollTop: 0,
                dragging: false
            },
            image: {
                scrollHeight: 0,
                scrollTop: 0,
                knob: React.createRef<HTMLDivElement>(),
                knobRail: React.createRef<HTMLDivElement>(),
                knobRailHeight: 0,
                knobHeight: 0,
                startY: 0,
                startScrollTop: 0,
                dragging: false
            }
        };

    sections: Array<{
        uid: string;
        title: string;
        text: {
            start: number;
            end: number;
            full: number;
            activeStart: number;
            activeEnd: number;
        },
        image: {
            start: number;
            end: number;
            full: number;
            activeStart: number;
            activeEnd: number;
        }
    }> = [];

    interactionObserver: IntersectionObserver;

    constructor(props: PageSectionProps) {
        super(props);

        this.textColumn = React.createRef<HTMLDivElement>();
        this.imageColumn = React.createRef<HTMLDivElement>();
        // this.introTitle = React.createRef<HTMLHeadingElement>();
        this.navContainer = React.createRef<HTMLDivElement>();
        this.subNavContainer = React.createRef<HTMLDivElement>();
        this.subNavTitleContainer = React.createRef<HTMLDivElement>();
        this.container = React.createRef<HTMLDivElement>();

        this._onTextScroll = this._onTextScroll.bind(this);
        this._onTextScrollAsync = this._onTextScrollAsync.bind(this);

        this._onImageScroll = this._onImageScroll.bind(this);
        this._onImageScrollAsync = this._onImageScrollAsync.bind(this);

        this._toggleImageMode = this._toggleImageMode.bind(this);

        this._FlattenedImages = this._FlattenedImages.bind(this);
        this._biggestImageRatio = this._biggestImageRatio.bind(this);
        this._toggleTeaser = this._toggleTeaser.bind(this);

        this._onTransitionEnd = this._onTransitionEnd.bind(this);

        this._onResize = debounce(this._onResize.bind(this), 500);

        this._KnobTextMove = this._KnobTextMove.bind(this);
        this._KnobTextUp = this._KnobTextUp.bind(this);
        this._KnobTextDown = this._KnobTextDown.bind(this);

        this._KnobImageMove = this._KnobImageMove.bind(this);
        this._KnobImageUp = this._KnobImageUp.bind(this);
        this._KnobImageDown = this._KnobImageDown.bind(this);

        this._fullscreen = this._fullscreen.bind(this);

        this.state = {
            ImageMode: false,
            currentSlide: 0,
            isMobile: window.innerWidth < 768
        }
    }
    componentDidUpdate() {
        this._centerFirstImage();
        this._refreshSections();
        this._updateLegendOpacity();
    }
    componentDidMount() {
        this._centerFirstImage();

        this._refreshSections();
        this._refreshKnobSizes();
        this._refreshObserver();
        this._updateLegendOpacity();

        window.addEventListener('resize', this._onResize);
        let { location: { hash } } = window;
        if (hash) {
            hash = hash.replace("#", "");
            const section = this.sections.findIndex(o => o.uid === hash);
            if (section > 0) {
                this._ScrollTo(section);
            }
        }
        setTimeout(() => this._refreshSections(), 500);
        // window.addEventListener('keydown', () => this._toggleImageMode());
    }

    componentWillUnmount() {
        this._removeObserver();
        window.removeEventListener('resize', this._onResize);
    }
    render() {
        // const { isMobile } = this.state;
        return (
            <React.Fragment>
                {this._RenderDesktop()}
                {this._RenderMobile()}
            </React.Fragment >);
    }
    private _RenderDesktop() {
        const { Sections, Title: SectionTitle, Color, Files, TitleFiles } = this.props;
        const { ImageMode } = this.state;
        return (<div className={ClassNames("page-section", "", 'desktop', ImageMode ? "image-mode-enabled" : "")}>
            <div
                className={ClassNames("page-section", "column", "text")}
                style={{ backgroundColor: Color }}
                onMouseEnter={() => this.scrolling = "text"}
                onTouchStart={() => this.scrolling = "text"}
            >
                {Sections.length > 1 &&
                    <React.Fragment>

                        <nav
                            className="page-section__sub-nav"
                            ref={this.subNavContainer}
                        >
                            <div className={ClassNames('page-section', 'sub-nav-items')}>
                                {Sections.map((section, sectionIndex) => (
                                    <div
                                        key={section.UID}
                                        className={ClassNames("page-section", "sub-nav-item")}
                                    >
                                        <a
                                            onClick={() => this._ScrollTo(sectionIndex)}
                                        >
                                            {section.Title.split(/\n/g).map((part, i) =>
                                                <React.Fragment key={`${sectionIndex}-${i}`}>
                                                    {i !== 0 ? <br /> : null}{part}
                                                </React.Fragment>
                                            )}
                                        </a>
                                    </div>
                                ))}
                            </div>
                            <div className="page-section__sub-nav-fake" ref={this.subNavTitleContainer} />
                        </nav>
                    </React.Fragment>
                }
                <div
                    className={ClassNames("page-section", "knob-rail", "text")}
                    ref={this.scroll.text.knobRail}
                    onMouseDown={this._KnobTextDown}
                >
                    <div
                        className={ClassNames("page-section", "knob")}
                        ref={this.scroll.text.knob}
                    />
                </div>
                <div
                    onScroll={this._onTextScroll}
                    ref={this.textColumn}
                    className={ClassNames("page-section", "column-content", "text")}
                >

                    <div
                        className={ClassNames("page-section", "title")}
                    >
                        <Title title={SectionTitle} />
                    </div>
                    <nav
                        className="page-section__nav"
                        ref={this.navContainer}
                    >

                        {Sections.length > 1 && Sections.map((section, i) => (
                            <div
                                key={section.UID}
                                className={ClassNames("page-section", "nav-anchor")}
                                onClick={() => this._ScrollTo(i)}
                            >
                                <span>
                                    {section.Title.split(/\n/g).map((part, e) =>
                                        <React.Fragment key={`${i}-${e}`}>
                                            {e !== 0 ? <br /> : null}{part}
                                        </React.Fragment>
                                    )}
                                </span>
                            </div>
                        ))}
                    </nav>
                    {Sections.map((section, i) => (
                        <div
                            className={ClassNames("page-section", "text-section")}
                            data-section={section.UID}
                            key={section.UID}
                        >
                            <h4
                                className={ClassNames("page-section", "section-title")}
                                style={{ backgroundColor: Color }}
                            >
                                {section.Title.split(/\n/g).map((part, c) =>
                                    <React.Fragment key={`${i}-${c}`}>{c !== 0 ? <br /> : null}{part}</React.Fragment>
                                )}
                            </h4>
                            <div
                                key={section.UID}
                                className={ClassNames("page-section", "text")}
                                dangerouslySetInnerHTML={{ __html: section.Content }}
                            />
                            {
                                i === (Sections.length - 1) && Files && Files.length > 0 &&
                                <div
                                    className={ClassNames("page-section", "files")}
                                >
                                    {TitleFiles.length > 0 &&
                                        <div className={ClassNames('page-section', 'files-title')}>
                                            {TitleFiles}
                                        </div>
                                    }
                                    {Files.map((file, c) => (
                                        <div className={ClassNames('page-section', 'file-outer')}>
                                            <a
                                                key={c}
                                                href={file.Src}
                                                target='blank'
                                                className={ClassNames('page-section', 'file-btn')}
                                                data-color={Color}
                                            >
                                                {file.Legend}
                                                <span
                                                    className={ClassNames('page-section', 'fake-bg')}
                                                    style={{ color: Color }}
                                                >
                                                    {file.Legend}
                                                </span>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                    ))}
                </div>
            </div>
            <div
                className={ClassNames("page-section", "column", "images", ImageMode ? "image-mode" : "")}
                onMouseEnter={() => this.scrolling = "image"}
                onTouchStart={() => this.scrolling = "image"}
                onTransitionEnd={this._onTransitionEnd}
            >
                <a
                    className={ClassNames("page-section", "image-mode-toggler")}
                    onClick={this._toggleImageMode}
                >
                    <img
                        src={ArrowRight}
                        alt='Arrow icon enable image mode'
                        className={ClassNames('page-section', 'arrow-right-icon', ImageMode ? "" : "show")}
                    />
                    <img
                        src={ArrowLeft}
                        alt='Arrow icon enable image mode'
                        className={ClassNames('page-section', 'arrow-left-icon', ImageMode ? "show" : "")}
                    />
                </a>
                <div
                    className={ClassNames("page-section", "knob-rail", "image")}
                    ref={this.scroll.image.knobRail}
                >
                    <div
                        className={ClassNames("page-section", "knob")}
                        ref={this.scroll.image.knob}
                        onMouseDown={this._KnobImageDown}
                    />
                </div>

                <div
                    ref={this.imageColumn}
                    onScroll={this._onImageScroll}
                    className={ClassNames("page-section", "column-content", "image")}
                >
                    {Sections.map((section, s) => (
                        <div
                            className={ClassNames("page-section", "image-section")}
                            data-section={section.UID}
                            key={section.UID}
                        >
                            {s === 0 && <div className='page-section__fake-element' />}
                            <h4
                                className={ClassNames('page-section', 'image-section-title')}
                                style={s > 0 ? { paddingBottom: 0 } : {}}
                            >
                                {section.Title}
                            </h4>
                            {
                                section.SectionItems.map((item, i) => (
                                    <React.Fragment key={`${s}-${i}`}>
                                        {item.type === "SectionImages" &&
                                            <SectionImages
                                                RequestFullScreen={this._fullscreen}
                                                ImageMode={ImageMode}
                                                {...item as SectionImagesDto}
                                            />
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    ))}
                </div>
            </div>
        </div>);
    }

    private _RenderMobile() {
        const { Sections, Title: SectionTitle, Color, StartingImage, Files, TitleFiles } = this.props;
        const { teaserOpen } = this.state;
        return (
            <div className={ClassNames('page-section', '', 'mobile')}>
                <div
                    className={ClassNames('page-section', 'title-container-mobile')}
                    style={{ backgroundColor: Color }}
                >
                    <Title title={SectionTitle} />
                </div>
                <figure className={ClassNames('page-section', 'start-image-mobile')}>
                    <Image
                        pictureRef={StartingImage}
                        className='page-section__start-img'
                        sizes='100vw'
                    />
                </figure>
                {Sections.map((section, c) => {
                    const images = this._FlattenedImages(section);

                    return (
                        <section
                            className={ClassNames('page-section', 'section-mobile')}
                            key={section.UID}
                            id={`m-${section.UID}`}
                        >
                            <h3 className={ClassNames('page-section', 'section-title-mobile')}>
                                {section.Title.split(/\n/g).map((part, i) =>
                                    <React.Fragment key={`${c}-${i}`}>{i !== 0 ? <br /> : null}{part}</React.Fragment>
                                )}
                            </h3>
                            <div
                                id={section.UID}
                                className={
                                    ClassNames(
                                        'page-section',
                                        'text-content',
                                        teaserOpen === section.UID ? 'teaser-open' : '')
                                }
                            >
                                {section.Teaser.length > 0 &&
                                    <div className={ClassNames('page-section', 'section-teaser')}>
                                        {section.Teaser.split(/\n/g).map((part, i) =>
                                            <React.Fragment key={`${c}-${i}`}>
                                                {i !== 0 ? <br /> : null}{part}
                                            </React.Fragment>
                                        )}
                                    </div>
                                }
                                <div
                                    className={
                                        ClassNames('page-section', 'more-btn-mobile', teaserOpen ? "show" : 'hide')
                                    }
                                    onClick={() => this._toggleTeaser(section.UID)}
                                >
                                    <TranslatedMessage id="see-less" defaultMessage={"fermer"} />
                                </div>
                                <div
                                    className={ClassNames('page-section', 'text-mobile')}
                                    dangerouslySetInnerHTML={{ __html: section.Content }}
                                />
                                <div
                                    className={ClassNames('page-section', 'more-btn-mobile', 'show')}
                                    onClick={() => this._toggleTeaser(section.UID)}
                                >
                                    {!teaserOpen ?
                                        <TranslatedMessage id="see-more" defaultMessage={"voir +"} /> :
                                        <TranslatedMessage id="see-less" defaultMessage={"fermer"} />
                                    }
                                </div>
                            </div>
                            <div
                                className={ClassNames('page-section', 'slider-mobile')}
                            >
                                <Slider
                                    units="%"
                                    nodes={
                                        images.map(i =>
                                            (<Image
                                                className={'page-section__slider-image'}
                                                pictureRef={i}
                                                sizes='100vw'
                                            />)
                                        )}
                                    onChange={(i) => this.setState(() => ({
                                        currentSlide: i
                                    }))}
                                    width={100}>
                                    <div
                                        className={ClassNames('page-section', 'slider-rail')}
                                        style={{ paddingBottom: `${this._biggestImageRatio(images)}%` }}
                                    >
                                        <Slider.Rail />
                                    </div>

                                    {images.length > 0 && <Slider.Consumer>
                                        {(slider) =>
                                            (<React.Fragment>
                                                <div className={ClassNames('page-section', 'slider-controls')}>
                                                    {images.map((s, i) =>
                                                        <Slider.Control key={`slide-${i}`} goto={i}>
                                                            <div
                                                                className={
                                                                    ClassNames('page-section',
                                                                        'bullet',
                                                                        slider.index === i ? "active" : '')
                                                                }
                                                            />
                                                        </Slider.Control>
                                                    )}
                                                </div>
                                                <div className={ClassNames('page-section', 'legends')}>
                                                    {images.map((s, i) => {
                                                        const regExp = /\$([^\$]*)\$/gi;
                                                        const legend =
                                                            s.Legend.replace(regExp, (m, g) =>
                                                             `<em>${g}</em>`).replace(/\n/g, '<br />');
                                                        return (<div
                                                            key={`legend-${i}`}
                                                            className={ClassNames('page-section',
                                                                'legend', slider.index === i ? "show" : '')
                                                            }
                                                            style={{ transform: `translateX(-${i * 100}%)` }}
                                                            dangerouslySetInnerHTML={{ __html: legend }}
                                                        />)
                                                    })}
                                                </div>
                                            </React.Fragment>)
                                        }
                                    </Slider.Consumer>
                                    }
                                </Slider>
                            </div>
                        </section>
                    );
                })}
                {Files && Files.length > 0 &&
                    <div
                        className={ClassNames("page-section", "files")}
                    >
                        {TitleFiles.length > 0 &&
                            <div className={ClassNames('page-section', 'files-title')}>
                                {TitleFiles}
                            </div>
                        }
                        {Files.map((file, i) => (
                            <div className={ClassNames('page-section', 'file-outer')}>
                                <a
                                    key={i}
                                    href={file.Src}
                                    target='blank'
                                    className={ClassNames('page-section', 'file-btn')}
                                    data-color={Color}
                                >
                                    {file.Legend}
                                    <span
                                        className={ClassNames('page-section', 'fake-bg')}
                                        style={{ color: Color }}
                                    >
                                        {file.Legend}
                                    </span>
                                </a>
                            </div>
                        ))}
                    </div>
                }
            </div>);
    }

    private _toggleTeaser(UID: string) {
        const { teaserOpen } = this.state;
        const section = document.getElementById(`m-${UID}`);
        if (!section) { return; }

        scrollroot.scrollTo({
            top: section.offsetTop
        });

        if (teaserOpen === UID) {
            this.setState(() => ({ teaserOpen: undefined }));
            return;
        }

        this.setState(() => ({ teaserOpen: UID }));
    }

    private _FlattenedImages(section: SectionDto) {
        const slides: PictureRef[] = [];
        const sectionItems = section.SectionItems;

        sectionItems
            .filter(i => i.type === "SectionImages")
            .forEach(i => (i as SectionImagesDto).Images.forEach(image => slides.push(image)));

        return slides;
    }
    private _biggestImageRatio(images: PictureRef[]): number {
        const ratios: number[] = [];

        images.forEach(image => ratios.push(image.Height / image.Width * 100));

        return Math.max(...ratios);
    }

    private _centerFirstImage() {
        const {
            imageColumn: { current: imageColumn }
        } = this;
        if (!imageColumn) { return; }
        const fakeElement = imageColumn!.querySelector(".page-section__fake-element") as HTMLElement;
        const image = imageColumn!.querySelector(".section-images__image") as HTMLElement;
        if (!image) { return; }
        const wrap = image.querySelector(".section-images__image-wrap") as HTMLElement;
        image.style.paddingTop = `0`;

        const h = wrap.clientHeight / 2;
        fakeElement.style.height = `calc(50vh - ${h}px)`;
    }

    private _refreshObserver() {
        if (this.interactionObserver) { return; }

        const {
            imageColumn: { current: imageColumn }
        } = this;

        const imageSections = Array.prototype.slice.call(
            imageColumn!.querySelectorAll(".section-images__image")
        ) as HTMLDivElement[];

        // const threshold = [];
        // for (let i = 0; i <= 1.0; i += 0.01) {
        //     threshold.push(i);
        // }
        // const options = {
        //     threshold
        // }

        // this.interactionObserver = new IntersectionObserver(this._onInteraction.bind(this), options);
        // imageSections.forEach(imageSection => this.interactionObserver.observe(imageSection));
        this.scroll.legends = imageSections;
    }

    private _removeObserver() {
        if (!this.interactionObserver) { return; }
        this.interactionObserver.disconnect();

    }

    private _ScrollTo(index: number) {
        const {
            textColumn: { current: textColumn }
        } = this;

        const section = this.sections[index];
        textColumn!.scrollTo({ top: section.text.activeStart, behavior: 'smooth' });
    }

    // private _onInteraction(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {

    //     this.scroll.legends = [];
    //     // tslint:disable-next-line:no-console
    //     console.log(entries);
    //     entries.forEach(e => {
    //         const img = e.target.querySelector(".section-images__images") as HTMLElement;
    //         if (img) { img.style.display = e.isIntersecting ? "block" : "none"; }

    //         if (e.isIntersecting) {
    //             this.scroll.legends.push(e.target as HTMLDivElement);
    //         }

    //     });
    // }
    private _updateLegendOpacity() {
        const { scroll: { clientHeight, legends } } = this;
        legends.forEach(item => {
            const image = item.querySelector(".section-images__image-ratio") as HTMLElement;

            const { top, height } = image.getBoundingClientRect();

            const inViewPort = top > -height && top < clientHeight;
            const img = item.querySelector(".section-images__images") as HTMLElement;
            img.style.display = inViewPort ? "block" : "none";

            // const legend = item.querySelector(".section-images__infos") as HTMLElement;

            // if (!legend) { return; }

            // const topCenter = (clientHeight - height) / 2 - height * 0.2;
            // const show = Math.abs(top - topCenter) < 0.2 * clientHeight;

            // legend.classList.toggle("section-images__infos--show", show);

        })

    }

    private _onResize() {
        this.setState({ isMobile: window.innerWidth < 768 });
        this._refreshKnobSizes();
        this._centerFirstImage();
        this._refreshSections();
        this._refreshObserver();
        this._updateLegendOpacity();
    }

    private _onTransitionEnd() {
        this._refreshKnobSizes();
        this._centerFirstImage();
        this._refreshSections();
        this._refreshObserver();
        this._refreshKnobPositions();
        this._updateLegendOpacity();
    }

    private _refreshSections() {

        const {
            state: { isMobile },
            textColumn: { current: textColumn },
            imageColumn: { current: imageColumn }
        } = this;

        const clientHeight = imageColumn!.clientHeight;
        this.scroll.clientHeight = clientHeight;

        if (isMobile) { return; }

        const textSections = Array.prototype.slice.call(
            textColumn!.querySelectorAll("[data-section]")
        ) as HTMLElement[];

        const imageSections = Array.prototype.slice.call(
            imageColumn!.querySelectorAll("[data-section]")
        ) as HTMLElement[];

        const getBounds = (elt: HTMLElement, i: number) => {
            const start = i === 0 ? 0 : (elt.offsetTop - clientHeight);
            const end = i === 0 ?
                (elt.offsetTop + elt.clientHeight - clientHeight) :
                (elt.offsetTop - clientHeight + elt.clientHeight);
            const full = end - start;
            const activeStart = elt.offsetTop;
            const activeEnd = elt.offsetTop + elt.clientHeight;
            return { start, end, full, activeStart, activeEnd };
        };

        this.sections = textSections.map((text, i) => {
            const image = imageSections[i];
            const title = text.querySelector(".page-section__section-title");
            return {
                uid: text.getAttribute("data-section") || "",
                title: (title && title.innerHTML) || '',
                text: getBounds(text, i),
                image: getBounds(image, i)
            };
        });

        this.scroll = {
            ...this.scroll,
            clientHeight: imageColumn!.clientHeight,
            image: { ...this.scroll.image, scrollHeight: imageColumn!.scrollHeight, scrollTop: imageColumn!.scrollTop },
            text: { ...this.scroll.text, scrollHeight: textColumn!.scrollHeight, scrollTop: textColumn!.scrollTop }
        }
    }

    private _KnobTextDown(ev: React.MouseEvent<HTMLDivElement>) {
        const {
            textColumn: { current: textColumn }
        } = this;

        this.scroll.text.dragging = true;
        this.scroll.text.startY = ev.pageY;
        this.scroll.text.startScrollTop = textColumn!.scrollTop;

        window.addEventListener("mousemove", this._KnobTextMove);
        window.addEventListener("mouseup", this._KnobTextUp);
        ev.preventDefault();
        ev.stopPropagation();
    }
    private _KnobTextMove(ev: MouseEvent) {
        const y = ev.pageY;
        const {
            textColumn: { current: textColumn },
            scroll: {
                clientHeight,
                text: { startY, startScrollTop, scrollHeight, knobRailHeight }
            }
        } = this;

        const delta = y - startY;

        textColumn!.scrollTop = startScrollTop + (delta / knobRailHeight) * (scrollHeight - clientHeight);
        ev.preventDefault();
        ev.stopPropagation();
    }

    private _KnobTextUp(ev: MouseEvent) {
        this.scroll.text.dragging = false;
        window.removeEventListener("mousemove", this._KnobTextMove);
        window.removeEventListener("mouseup", this._KnobTextUp);
        ev.preventDefault();
        ev.stopPropagation();
    }

    private _KnobImageDown(ev: React.MouseEvent<HTMLDivElement>) {
        const {
            imageColumn: { current: imageColumn }
        } = this;

        this.scroll.image.dragging = true;
        this.scroll.image.startY = ev.pageY;
        this.scroll.image.startScrollTop = imageColumn!.scrollTop;

        window.addEventListener("mousemove", this._KnobImageMove);
        window.addEventListener("mouseup", this._KnobImageUp);
        ev.preventDefault();
        ev.stopPropagation();
    }
    private _KnobImageMove(ev: MouseEvent) {
        const y = ev.pageY;
        const {
            imageColumn: { current: imageColumn },
            scroll: {
                clientHeight,
                image: { startY, startScrollTop, scrollHeight, knobRailHeight }
            }
        } = this;

        const delta = y - startY;

        imageColumn!.scrollTop = startScrollTop + (delta / knobRailHeight) * (scrollHeight - clientHeight);
        ev.preventDefault();
        ev.stopPropagation();
    }

    private _KnobImageUp(ev: MouseEvent) {
        this.scroll.image.dragging = false;
        window.removeEventListener("mousemove", this._KnobImageMove);
        window.removeEventListener("mouseup", this._KnobImageUp);
        ev.preventDefault();
        ev.stopPropagation();
    }

    private _updateSubTitles() {
        const {
            navContainer: { current: navContainer },
            scroll: {
                clientHeight,
                text: { scrollTop: scrollTopText } }
        } = this;

        let scrollTop = scrollTopText;

        scrollTop = Math.min(scrollTop, clientHeight);

        const percent = scrollTop / clientHeight;
        // navContainer!.style.opacity = (1 - percent).toString();
        const y = percent * -50;
        if (navContainer) {
            navContainer.style.transform = `translate3d(0%,${y}vh,0)`;
            navContainer.classList.toggle("page-section__nav--hidden", percent === 1);
        }

    }
    private _refreshKnobSizes() {
        const {
            imageColumn: { current: imageColumn },
            textColumn: { current: textColumn },
            scroll: {
                clientHeight,
                text: {
                    scrollHeight: scrollHeightText,
                    knob: { current: textKnob },
                    knobRail: { current: textKnobRail }
                },
                image: {
                    scrollHeight: scrollHeightImage,
                    knob: { current: imageKnob },
                    knobRail: { current: imageKnobRail }
                }
            }
        } = this;
        const refreshSize = (
            scroller: HTMLDivElement,
            knobRail: HTMLDivElement,
            knob: HTMLDivElement,
            knobRailHeight: number,
            scrollHeight: number
        ) => {
            const r = clientHeight / scrollHeight;
            const h = r < 1 ? r * knobRailHeight : 0;
            const active = r < 1;
            scroller.style.marginRight = active ? `-${scrollbarWidth}px` : '0';
            knobRail.style.display = active ? 'block' : 'none';
            knob.style.height = `${h}px`;
            return h;
        }
        if (textColumn && textKnob && textKnobRail) {
            const kRHeight = textKnobRail.clientHeight;
            this.scroll.text.knobRailHeight = kRHeight;
            this.scroll.text.knobHeight = refreshSize(textColumn, textKnobRail, textKnob, kRHeight, scrollHeightText);
        }
        if (imageColumn && imageKnob && imageKnobRail) {
            const kRHeight = imageKnobRail.clientHeight;
            this.scroll.image.knobRailHeight = kRHeight;
            this.scroll.image.knobHeight =
                refreshSize(imageColumn, imageKnobRail, imageKnob, kRHeight, scrollHeightImage);
        }
    }
    private _refreshKnobPositions() {
        const {
            scroll: {
                clientHeight,
                text: {
                    scrollHeight: scrollHeightText,
                    scrollTop: scrollTopText,
                    knobHeight: knobHeightText,
                    knob: {
                        current: textKnob
                    }
                },
                image: {
                    scrollHeight: scrollHeightImage,
                    scrollTop: scrollTopImage,
                    knobHeight: knobHeightImage,
                    knob: {
                        current: imageKnob
                    }
                }
            }
        } = this;

        const refreshTop = (knob: HTMLDivElement, scrollHeight: number, scrollTop: number, knobHeight: number) => {
            const maxScrollTop = scrollHeight - clientHeight;
            const p = scrollTop / maxScrollTop;
            const minTop = 0;
            const maxTop = clientHeight - knobHeight;
            knob.style.transform = `translate3d(0%,${(maxTop - minTop) * p}px,0)`;
        }

        if (textKnob) {
            refreshTop(textKnob, scrollHeightText, scrollTopText, knobHeightText);
        }
        if (imageKnob) {
            refreshTop(imageKnob, scrollHeightImage, scrollTopImage, knobHeightImage);
        }
    }
    private _onTextScrollAsync() {
        const {
            imageColumn: { current: imageColumn },
            subNavTitleContainer: { current: subNavTitleContainer },
            scroll: { clientHeight, text: { scrollTop: lastScrollTextY } }
        } = this;

        const index = this.sections.findIndex(s => s.text.start <= lastScrollTextY && s.text.end > lastScrollTextY);

        if (index < 0) {
            this.ticking = false;
            return;
        }

        const section = this.sections[index];

        if (section && subNavTitleContainer) {
            subNavTitleContainer.innerHTML = (lastScrollTextY <= clientHeight) ? '' : section.title;
        }
        if (window.location.hash.replace("#", "") !== section.uid) {
            setTimeout(() => window.location.hash = section.uid);
        }

        const currentScroll = lastScrollTextY - section.text.start;
        const percent = currentScroll / section.text.full;

        const top = section.image.start + section.image.full * percent;
        imageColumn!.scrollTop = top;
        this.scroll.image.scrollTop = top;

        this._updateSubTitles();
        this._refreshKnobPositions();
        this._updateLegendOpacity();
        this.ticking = false;
    }

    private _onTextScroll() {
        if (this.scrolling === "image") { return; }
        // tslint:disable-next-line:no-console
        console.log("text scroll")
        const {
            textColumn: { current: textColumn }
        } = this;

        this.scroll.text.scrollTop = textColumn!.scrollTop;

        if (!this.ticking) {
            requestAnimationFrame(this._onTextScrollAsync);
            this.ticking = true;
        }
    }

    private _onImageScrollAsync() {
        const {
            textColumn: { current: textColumn },
            subNavTitleContainer: { current: subNavTitleContainer },
            scroll: {
                clientHeight,
                image: { scrollTop: lastScrollImageY }
            }
        } = this;

        const index = this.sections.findIndex(s => s.image.start <= lastScrollImageY && s.image.end > lastScrollImageY);

        if (index < 0) {
            this.ticking = false;
            return;
        }

        const section = this.sections[index];

        if (window.location.hash.replace("#", "") !== section.uid) {
            setTimeout(() => window.location.hash = section.uid);
        }

        const currentScroll = lastScrollImageY - section.image.start;
        const percent = currentScroll / section.image.full;

        const top = section.text.start + section.text.full * percent;
        textColumn!.scrollTop = top;
        this.scroll.text.scrollTop = top;

        this._updateSubTitles();
        this._refreshKnobPositions();
        this._updateLegendOpacity();

        if (section && subNavTitleContainer) {
            subNavTitleContainer.innerHTML = (top <= clientHeight) ? '' : section.title;
        }
        this.ticking = false;
    }

    private _onImageScroll() {

        if (this.scrolling === "text") { return; }
        // tslint:disable-next-line:no-console
        console.log("image scroll")
        const {
            imageColumn: { current: imageColumn }
        } = this;

        this.scroll.image.scrollTop = imageColumn!.scrollTop;
        if (!this.ticking) {
            requestAnimationFrame(this._onImageScrollAsync);
            this.ticking = true;
        }
    }

    private _toggleImageMode(e: React.MouseEvent<HTMLAnchorElement>) {
        const ImageMode = !this.state.ImageMode;
        this.setState(() => ({ ImageMode }));
        document.body.classList.toggle("body--image-mode", ImageMode);

    }

    private _ScrollToImage(link: HTMLElement) {
        const {
            imageColumn: { current: imageColumn },
            scroll: { clientHeight }
        } = this;
        let p = link;
        let pos = 0;
        while (p && p !== imageColumn) {
            if (window.getComputedStyle(p).position === "relative") {
                pos += p.offsetTop;
            }
            p = p.parentElement as HTMLElement;
        }
        pos -= (clientHeight - link.parentElement!.clientHeight) / 2;
        imageColumn!.scrollTo({ top: pos, behavior: 'smooth' });
    }

    private _fullscreen(e: React.MouseEvent<HTMLElement>) {
        const ImageMode = true;
        this.setState(() => ({ ImageMode }));
        document.body.classList.toggle("body--image-mode", ImageMode);
        const link = e.target as HTMLElement;
        if (link) {
            setTimeout(() => this._ScrollToImage(link), 500);
        }
    }
}
export const PageSection = PageSectionWrapped;
export default PageSection;


// WEBPACK FOOTER //
// ./src/Components/PageSection/PageSection.tsx